import React, { MouseEventHandler } from 'react';
import styles from './LabelButton.module.scss';
import Clickable from '../Clickable';

type Props = {
  label: string;
  onClick?: MouseEventHandler;
  disable?: boolean;
  type?: 'primary' | 'link' | 'danger' | 'square' | 'normal';
  width?: string;
}

const LabelButton: React.FC<Props> = ({
  label,
  onClick,
  disable = false,
  type = 'primary',
  width = '0',
}) => {
  const clickHandler: MouseEventHandler = (e) => {
    if (onClick) {
      onClick(e);
    }
  };
  const classMap: any = {
    primary: styles.primary,
    link: styles.link,
    square: styles.square,
    normal: styles.normal,
  };
  return (
    <Clickable event={clickHandler} label={label} disable={disable}>
      <span
        className={`${styles.button} ${classMap[type]} ${disable ? styles.disable : ''}`}
        style={{ width: width || 'auto' }}
      >
        {label}
      </span>
    </Clickable>
  );
};

export default LabelButton;
